import {useCallback, useEffect, useRef, useState} from 'react'
import {Col, Form, Modal, Row} from 'react-bootstrap'
import {TFormKeys, TTabForm} from '../policiesTypes'
import {PolicyHolderTabModal} from './PolicyHolderTabModal'
import {BasicPolicyInfoTab} from './BasicPolicyInfoTab'
import {AddressInfoTab} from './AddressInfoTab'
import {useFormik} from 'formik'
import {useLazyQuery, useMutation, useQuery} from '@apollo/client'
import {CREATE_POLICY, UPDATE_POLICY_FULL} from '../../../gql/mutations/policyMutation'
import {toast} from 'react-toastify'
import {IResCreatePolicyApi, IResCreateQuoteApi, IResPolicyTypeCategories, IResUpdatePolicyFullApi} from '../../../types/policies'
import {parseId} from '../../../helpers'
import {useNavigate} from 'react-router-dom'
import {getPolicyName, getMetalLevelValueByLabel, INIT_FORM_QUOTE_POLICY} from '../../../helpers/consts'
import {TABS_FORM} from '../../shared/const'
import {GET_ALL_POLICY_TYPE_CATEGORIES} from '../../../gql/queries/policyTypesQuery'
import {HouseholdInfoTab} from './HouseholdInfoTab'
import {FamilyMembersTabModal} from './FamilyMembersTabModal'
import * as Yup from 'yup'
import {GET_ONE_LEAD, GET_ZIP_INFO} from '../../../gql/queries/leadsQuery'
import {IResZipCode} from '../../../types/quoteTypes'
import {addMonths, format, startOfMonth} from 'date-fns'
import {IResAllUsers} from '../../oneUser/oneUserTypes'
import {GET_ALL_USERS_FILTER} from '../../../gql/queries/usersQuery'
import {CREATE_QUOTE} from '../../../gql/mutations/quotesMutations'
import {IResContactsAPI, IResOneContact, NodeContact} from '../../../types/contactsApi'
import {GET_ALL_CONTACTS_API, GET_ONE_CONTACT_API} from '../../../gql/queries/contactsApiQueries'
import {IResOneLead} from '../../leads/leadTypes'
import {Plan} from '../../oneLead/oneleadTypes'
import {SYNC_LEAD_CONTACT} from '../../../gql/mutations/leadMutations'
import {IResSyncContactLead} from '../../../types/leads'
import {GET_ALL_LEAD_SOURCES} from '../../../gql/queries/leadSourceQuery'
import {IResLeadSource} from '../../leadSource/leadSourceTypes'
import {useGetUser} from '../../../store/userStore'
import {IForm} from '../../oneAddQuote/oneQuoteTypes'
import {GET_OR_CREATE_INSURANCE_OPERATOR} from '../../../gql/mutations/carriersMutations'
import {IResCarriersList, IResGetOrCreateInsuranceOperator} from '../../../types/carriers'
import {GET_ALL_CARRIERS_LIST} from '../../../gql/queries/carriersQuery'
import {INIT_FORM_MEMBERS} from '../../../helpers/policyFormDefaults'

interface IModalProps {
  keyboard: boolean
  backdrop: string
  isOpen: boolean
  onClose: () => void
  refetch: () => void
  leadId?: string
  isQuote?: boolean
  idContact?: string
  planSelectPrev?: Plan
  isMedicarePolicyFlow?: boolean
  quickQuoteData?: IForm
}

export const ModalAddPolice: React.FC<IModalProps> = ({
  keyboard,
  backdrop,
  isOpen,
  onClose,
  refetch,
  leadId,
  isQuote = false,
  idContact,
  planSelectPrev,
  isMedicarePolicyFlow = false,
  quickQuoteData,
}) => {
  const primaryGroup = useGetUser((s) => s.user?.user?.primaryGroup)
  const isAgent = primaryGroup?.name === 'Agente'

  const [leadEdited, setSyncContactLead] = useState(false)

  const [gqlGetLead, {data: dataLead}] = useLazyQuery<IResOneLead>(GET_ONE_LEAD, {
    fetchPolicy: 'no-cache',
  })
  const [gqlSyncContactLead, {data: dataEdit}] = useMutation<IResSyncContactLead>(SYNC_LEAD_CONTACT)

  const [
    gqlGetContacts,
    {data: dataAllContacts, refetch: refetchContacts},
  ] = useLazyQuery<IResContactsAPI>(GET_ALL_CONTACTS_API, {
    fetchPolicy: 'no-cache',
  })

  useEffect(() => {
    if (leadEdited) return
    //Update Lead for create Contact
    if (dataLead) {
      console.log('gqlSyncContactLead dataLead:', dataLead.leadById.id)
      gqlSyncContactLead({
        variables: {
          leadId: dataLead.leadById.id ? parseId(dataLead.leadById.id) : '',
        },
      })
      setSyncContactLead(true)
      refetchContacts()
      console.log('refetchContacts')
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataLead])

  useEffect(() => {
    console.log('useEffect dataAllContacts', dataAllContacts)
    if (!dataAllContacts) return

    const contactNode = dataAllContacts?.allContacts?.edges?.[0]?.node

    if (contactNode) {
      console.log('contactNode', contactNode)
      setInfoEditContact(contactNode)

      const zip = contactNode.zipCode
      if (zip) {
        getMarketByZip(zip)
      }
    } else if (leadId) {
      console.log('No contacts found for this lead')
      gqlGetLead({
        variables: {
          id: parseId(leadId),
        },
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataAllContacts])

  useEffect(() => {
    //First render of modal
    if (Number(leadId)) {
      console.log('gqlGetContacts leadId:', leadId)
      gqlGetContacts({
        variables: {
          lead: leadId ? parseId(leadId) : '',
        },
      })
      return
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [leadId])

  useEffect(() => {
    //First render of modal
    if (idContact) {
      getContact(idContact)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataEdit])

  useEffect(() => {
    //First render of modal
    if (idContact) {
      getContact(idContact)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [idContact])

  function mapContactToPolicyData(contact: NodeContact) {
    // console.log('contact:' + JSON.stringify(contact))
    return {
      policyName: contact.fullName,
      zipCode: contact.zipCode,
      address1: contact.address1,
      address2: contact.address2 || '',
      city: contact.city,
      stateName: contact.stateEU?.name ?? '',
      stateCode: contact.stateEU?.id ?? '',

      holder: {
        firstName: contact.firstName ?? '',
        middleName: contact.middleName ?? '',
        secondLastName: contact.secondLastName ?? '',
        lastName: contact.lastName ?? '',
        emailAddress: contact.email ?? '',
        dateBirth: contact.dateBirth ?? '',
        gender: contact.gender ?? '',
        phone: contact.phone ?? '',
        rol: 'HOLDER',
        applicant: true,
        annualIncome1: contact.annualIncome1?.replaceAll(',', ''),
        annualIncome2: contact.annualIncome2?.replaceAll(',', ''),
        annualIncome3: contact.annualIncome3?.replaceAll(',', ''),
      },
    }
  }

  const [infoEditContact, setInfoEditContact] = useState<NodeContact | null>(null)

  const [gqlGetContact, {data: dataGetContact}] =
    useLazyQuery<IResOneContact>(GET_ONE_CONTACT_API, {
      fetchPolicy: 'no-cache',
    })

  const getContact = (id: string) => {
    gqlGetContact({variables: {id: parseId(id)}})
  }

  useEffect(() => {
    //First render of modal
    if (idContact) {
      getContact(idContact)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [idContact])

  useEffect(() => {
    if (dataGetContact?.contactById) {
      setInfoEditContact(dataGetContact?.contactById)
      if (dataGetContact?.contactById?.zipCode) getMarketByZip(dataGetContact?.contactById?.zipCode)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataGetContact])

  const [gqlGetMembers, {data: dataUsers, loading: loadingUsers}] =
    useLazyQuery<IResAllUsers, {name: string; requireNpn: boolean}>(GET_ALL_USERS_FILTER)

  const [gqlGetMarket, {data: dataZipCode, loading: loadingZipCode}] =
    useLazyQuery<IResZipCode>(GET_ZIP_INFO, {
      fetchPolicy: 'no-cache',
    })

  const { data: allPolicyTypeCategories } = useQuery<IResPolicyTypeCategories>(
    GET_ALL_POLICY_TYPE_CATEGORIES,
    { fetchPolicy: 'no-cache' }
  )

  const { data: dataLeadSource } = useQuery<IResLeadSource>(
    GET_ALL_LEAD_SOURCES,
    {
      variables: { category: 'Policy', enabled: true },
      fetchPolicy: 'no-cache',
    }
  )

  const [lockPolicyType, setLockPolicyType] = useState(false)
  const [lockLeadSource, setLockLeadSource] = useState(false)
  const [medicareTypeId, setMedicareTypeId] = useState('')
  const [medicareSourceId, setMedicareSourceId] = useState('')
  const warnedMissingMedicareTypeRef = useRef(false)
  const warnedMissingMedicareSourceRef = useRef(false)
  const warnedMissingAcaTypeRef = useRef(false)
  const isAcaFlow = !!quickQuoteData
  

  const [gqlCreatePolicy, {data: dataCreate, loading: loadingCreate, error: errorCreate}] =
    useMutation<IResCreatePolicyApi>(CREATE_POLICY)

  const [
    gqlCreateQuote,
    {data: dataCreateQuote, loading: loadingCreateQuote, error: errorCreateQuote},
  ] = useMutation<IResCreateQuoteApi>(CREATE_QUOTE)

  const [gqlGetOrCreateOperator, {data: dataCarrierOp}] =
    useMutation<IResGetOrCreateInsuranceOperator>(GET_OR_CREATE_INSURANCE_OPERATOR)

  const [gqlUpdatePolicyFull, {data: dataUpdateFull}] = useMutation<IResUpdatePolicyFullApi>(UPDATE_POLICY_FULL)

  const pendingNavRef = useRef<{path: string; isQuoteFlow: boolean} | null>(null)

  const {data: dataCarriersList} = useQuery<IResCarriersList>(GET_ALL_CARRIERS_LIST, {
    fetchPolicy: 'cache-first',
  })

  const navigate = useNavigate()

  const [tabForm, setTabForm] = useState<TTabForm>('policy-holder')
  const [submitAttemptCount, setSubmitAttemptCount] = useState(0)
  const tabOrder: TTabForm[] = [
    'policy-holder',
    'address-info',
    'household-info',
    'family-members',
    'basic-policy-info',
  ]

  const filteredTabs = TABS_FORM.filter((tab) => tabOrder.includes(tab.tabName)).map((tab) => ({
    ...tab,
    ...tabOrder[tab.tabName],
  }))

  const fieldToTabMap: Record<string, TTabForm> = {
    // 🟦 Policy Holder Tab
    'holder.firstName': 'policy-holder',
    'holder.lastName': 'policy-holder',
    'holder.dateBirth': 'policy-holder',
    'holder.gender': 'policy-holder',
    'holder.phone': 'policy-holder',
    'holder.emailAddress': 'policy-holder',
    ownsCar: 'policy-holder',
    ownsHome: 'policy-holder',

    // 🟩 Address Info Tab
    address1: 'address-info',
    address2: 'address-info',
    zipCode: 'address-info',

    // 🟨 Basic Policy Info Tab
    typePolicy: 'basic-policy-info',
    leadSource: 'basic-policy-info',
    carrier: 'basic-policy-info',
    effectiveDate: 'basic-policy-info',
    user: 'basic-policy-info',
  }

  const minEffectiveDate = format(startOfMonth(addMonths(new Date(), 1)), 'yyyy-MM-dd')

  function mapRelationship(rel: string): string {
    const map: Record<string, string> = {
      spouse: 'Spouse',
      child: 'Child',
      domestic_partner: 'Life Partner',
      parent: 'Mother or Father',
      sibling: 'Brother or Sister',
      'life partner': 'Life Partner',
      'mother or father': 'Mother or Father',
      'brother or sister': 'Brother or Sister',
    }
    return map[rel?.toLowerCase()] || ''
  }

  function mapQuickQuoteToFormData(qd: IForm) {
    const numMembers = Number(qd.numberOfMembers) || 1
    return {
      zipCode: qd.zipCode || '',
      countyFips: qd.countyfips || '',
      stateEU: {id: qd.state || '', code: qd.state || '', name: ''},
      applicants: numMembers,
      members: numMembers,
      effectiveDate: qd.effectiveDate || minEffectiveDate,
      holder: {
        ...INIT_FORM_MEMBERS,
        dateBirth: qd.personOne.dob || '',
        gender: qd.personOne.gender || '',
        annualIncome1: qd.householdIncome?.replaceAll(',', '') || '',
      },
      policyMembers: (qd.people || []).map((person) => ({
        ...INIT_FORM_MEMBERS,
        dateBirth: person.dob || '',
        gender: person.gender || '',
        rol: 'FAMILY',
        applicant: true,
        relationship: mapRelationship(person.relationship),
      })),
    }
  }

  const planData = planSelectPrev
    ? {
        CMSPlanId: planSelectPrev.id || '',
        planName: planSelectPrev.name || '',
        metalLevel: Number(getMetalLevelValueByLabel(planSelectPrev.metal_level)) || 0,
        premium: String(planSelectPrev.premium_w_credit ?? ''),
        taxCredit: String(
          Math.max(0, (planSelectPrev.premium ?? 0) - (planSelectPrev.premium_w_credit ?? 0)).toFixed(2)
        ),
        policyTotalCost: String(planSelectPrev.premium ?? ''),
      }
    : {}

  const initialValues = {
    ...(infoEditContact
      ? {
          ...INIT_FORM_QUOTE_POLICY,
          ...mapContactToPolicyData(infoEditContact),
          effectiveDate: minEffectiveDate,
          applicants: 1,
        }
      : {...INIT_FORM_QUOTE_POLICY, effectiveDate: minEffectiveDate, applicants: 1}),
    ...(isAcaFlow && !infoEditContact ? mapQuickQuoteToFormData(quickQuoteData!) : {}),
    ...planData,
    ...(isMedicarePolicyFlow && medicareTypeId ? {typePolicy: {id: medicareTypeId}} : {}),
    ...(isMedicarePolicyFlow && medicareSourceId ? {leadSource: {id: medicareSourceId}} : {}),
  }

  const formik = useFormik({
    enableReinitialize: true,
    initialValues,
    validationSchema: Yup.object({
      holder: Yup.object({
        firstName: Yup.string().required('(required)'),
        lastName: Yup.string().required('(required)'),
        dateBirth: Yup.date().required('(required)'),
        gender: Yup.string().required('(required)'),
        phone: Yup.string().required('(required)'),
        emailAddress: Yup.string().email('Invalid email'),
      }),
      zipCode: Yup.string().required('(required)'),
      applicants: Yup.number().required('(required)').min(1, 'Must have at least 1 applicant'),
      effectiveDate: Yup.date().required('(required)'),
      ownsCar: Yup.boolean().nullable().required('(required)'),
      ownsHome: Yup.boolean().nullable().required('(required)'),
      user: Yup.object({
        id: Yup.mixed()
          .test('agent-required', 'Agent is required', (value) => {
            if (value === null || value === undefined || value === '') return false
            try {
              return parseId(String(value)) > 0
            } catch {
              return false
            }
          })
          .test('agent-valid', 'Please select an agent', (value) => {
            try {
              return parseId(String(value)) > 0
            } catch {
              return false
            }
          }),
      }),
      typePolicy: Yup.object({
        id: Yup.string().required('(required)'),
      }),
      leadSource: isAgent
        ? Yup.object().nullable()
        : Yup.object({
            id: Yup.string().required('(required)'),
          }),
    }),
    onSubmit: (v) => {
      const carrier = Number(parseId(v.carrier?.id))
      const typePolicy = Number(parseId(v.typePolicy?.id))
      const leadSource = v.leadSource?.id ? Number(parseId(v.leadSource.id)) : null
      const policyData = {
        policyName: v.policyName,
        applicants: Number(v.applicants) || 1,
        members: Number(v.members) || 0,
        dependents: Number(v.dependents) || 0,
        stateDocs: v.stateDocs,
        paymentStatus: v.paymentStatus,
        effectiveDate: v.effectiveDate,
        typePolicy: typePolicy > 0 ? typePolicy : null,
        leadSource: leadSource && leadSource > 0 ? leadSource : null,
        carrier: carrier > 0 ? carrier : null,
        zipCode: v.zipCode,
        address1: v.address1,
        address2: v.address2 || '',
        city: v.city,
        stateCode: v.stateEU?.code || '',
        user: v.user ? Number(parseId(v.user.id)) : undefined,
        commissionPayable: true, // o usa otro campo si viene de formik
        ownsCar: v.ownsCar ?? null,
        ownsHome: v.ownsHome ?? null,

        holderData: {
          firstName: v.holder.firstName,
          middleName: v.holder.middleName,
          secondLastName: v.holder.secondLastName,
          lastName: v.holder.lastName,
          emailAddress: v.holder.emailAddress,
          dateBirth: v.holder.dateBirth,
          gender: v.holder.gender,
          phone: v.holder.phone,
          rol: 'HOLDER',
          applicant: v.holder.applicant,
          annualIncome1: v.holder.annualIncome1?.replaceAll(',', ''),
          annualIncome2: v.holder.annualIncome2?.replaceAll(',', '') ?? '0',
          annualIncome3: v.holder.annualIncome3?.replaceAll(',', '') ?? '0',
          ...(idContact ? { contactId: idContact } : {}),
        },
        lead: leadId ? parseId(leadId) : null,
      }

      if (planSelectPrev) {
        Object.assign(policyData, {
          CMSPlanId: planSelectPrev.id,
          planName: planSelectPrev.name,
          metalLevel: Number(getMetalLevelValueByLabel(planSelectPrev.metal_level)) || 0,
          premium: planSelectPrev.premium_w_credit ?? 0,
          taxCredit: Math.max(
            0,
            (planSelectPrev.premium ?? 0) - (planSelectPrev.premium_w_credit ?? 0)
          ),
          policyTotalCost: planSelectPrev.premium ?? 0,
        })
      }

      if (isQuote) {
        console.log('Create Quote with input:', policyData)
        gqlCreateQuote({
          variables: {
            policyData,
          },
        })
      } else {
        console.log('Create Policy with input:', policyData)
        gqlCreatePolicy({
          variables: {
            policyData,
          },
        })
      }
    },
  })

  useEffect(() => {
    formik.values.policyName = getPolicyName(formik.values.holder)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    formik.values.holder.firstName,
    formik.values.holder.middleName,
    formik.values.holder.lastName,
    formik.values.holder.secondLastName,
  ])

  useEffect(() => {
    if (errorCreate) {
      toast.error(`Error Create Policy: ${errorCreate.message}`)
    }
    if (errorCreateQuote) {
      toast.error(`Error Create Quote: ${errorCreateQuote.message}`)
    }
  }, [errorCreate, errorCreateQuote])

  function saveMembersAndNavigate(policyRelayId: string, path: string, isQuoteFlow: boolean) {
    const numericId = parseId(policyRelayId)
    const membersToSave = formik.values.policyMembers.filter(
      (m) => m.dateBirth || m.firstName || m.lastName || m.gender
    )

    if (membersToSave.length > 0) {
      pendingNavRef.current = {path, isQuoteFlow}
      gqlUpdatePolicyFull({
        variables: {
          id: numericId,
          policyData: {},
          membersToCreate: membersToSave.map((m) => ({
            firstName: m.firstName || null,
            lastName: m.lastName || null,
            dateBirth: m.dateBirth || null,
            gender: m.gender || null,
            rol: m.rol || 'FAMILY',
            applicant: m.applicant ?? true,
            relationship: m.relationship || null,
            policy: String(numericId),
          })),
        },
      })
    } else {
      toast.success(isQuoteFlow ? 'Quote added successfully' : 'Policy added successfully')
      onClose()
      navigate(path)
    }
  }

  useEffect(() => {
    if (!dataCreate) return
    if (dataCreate.createPolicy?.policy?.id) {
      const id = dataCreate.createPolicy.policy.id
      saveMembersAndNavigate(id, `/one-policy/${id}`, false)
    } else if (dataCreate.createPolicy?.errors?.length > 0) {
      toast.error(`Error: ${dataCreate.createPolicy.errors[0]?.message || 'Something wrong'}`)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataCreate])

  useEffect(() => {
    if (!dataCreateQuote) return
    if (dataCreateQuote.createQuote?.policy?.id) {
      const id = dataCreateQuote.createQuote.policy.id
      saveMembersAndNavigate(id, `/one-quote/${id}`, true)
    } else if (dataCreateQuote.createQuote?.errors?.length > 0) {
      toast.error(`Error: ${dataCreateQuote.createQuote.errors[0]?.message || 'Something wrong'}`)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataCreateQuote])

  useEffect(() => {
    const nav = pendingNavRef.current
    if (!nav || !dataUpdateFull) return
    pendingNavRef.current = null
    if (!dataUpdateFull.updatePolicyFull?.success) {
      toast.warning('Policy created but some members could not be saved.')
    } else {
      toast.success(nav.isQuoteFlow ? 'Quote added successfully' : 'Policy added successfully')
    }
    onClose()
    navigate(nav.path)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataUpdateFull])

  const handleChange = useCallback((field: string, value: string | boolean | null) => {
    formik.setFieldValue(field, value)
    // console.log('Cambiando campo:', field, value)
  }, [formik.setFieldValue])
  const handleBlur = (field: TFormKeys) => {
    formik.setFieldTouched(field as string, true)
  }

  const getPrevTab = (currentTab: TTabForm): TTabForm | null => {
    const index = tabOrder.indexOf(currentTab)
    if (index > 0) {
      return tabOrder[index - 1]
    }
    return null // ya está en el primero
  }

  const getNextTab = (currentTab: TTabForm): TTabForm | null => {
    const index = tabOrder.indexOf(currentTab)
    if (index >= 0 && index < tabOrder.length - 1) {
      return tabOrder[index + 1]
    }
    return null // ya está en el último tab
  }

  const handleNextTab = async () => {
    const nextTab = getNextTab(tabForm)
    if (nextTab) setTabForm(nextTab)
  }
  const handlePrevTab = () => {
    const prevTab = getPrevTab(tabForm)
    if (prevTab) setTabForm(prevTab)
  }
  const flattenErrors = (obj: any, path = ''): string[] => {
    return Object.entries(obj).flatMap(([key, value]) => {
      const newPath = path ? `${path}.${key}` : key
      if (typeof value === 'string') {
        return [newPath]
      } else if (typeof value === 'object' && value !== null) {
        return flattenErrors(value, newPath)
      }
      return []
    })
  }

  const handleSubmit = async () => {
    setSubmitAttemptCount((prev) => prev + 1)
    const errors = await formik.validateForm()
    const ownershipRequiredError = '(required)'
    const ownsCarInvalid = typeof formik.values.ownsCar !== 'boolean'
    const ownsHomeInvalid = typeof formik.values.ownsHome !== 'boolean'

    if (ownsCarInvalid) {
      formik.setFieldTouched('ownsCar', true, false)
      formik.setFieldError('ownsCar', ownershipRequiredError)
    }

    if (ownsHomeInvalid) {
      formik.setFieldTouched('ownsHome', true, false)
      formik.setFieldError('ownsHome', ownershipRequiredError)
    }

    if (Object.keys(errors).length > 0 || ownsCarInvalid || ownsHomeInvalid) {
      const flatErrorFields = flattenErrors(errors)
      const firstErrorField =
        flatErrorFields[0] ||
        (ownsCarInvalid ? 'ownsCar' : ownsHomeInvalid ? 'ownsHome' : undefined)

      console.log('First error field:', firstErrorField)

      if (firstErrorField) {
        const targetTab = fieldToTabMap[firstErrorField]
        formik.setFieldTouched(firstErrorField, true, false)

        if (targetTab) setTabForm(targetTab)
      }
      return
    }

    // Envío del formulario si no hay errores
    formik.handleSubmit()
  }

  const addPolicyMember = () => {
    formik.setFieldValue('policyMembers', [
      ...formik.values.policyMembers,
      {...INIT_FORM_MEMBERS, rol: 'FAMILY', applicant: true},
    ])
  }

  const removePolicyMember = (index: number) => {
    const updated = [...formik.values.policyMembers]
    updated.splice(index, 1)
    formik.setFieldValue('policyMembers', updated)
  }

  const handleMemberChange = (index: number, field: string, value: string | boolean) => {
    formik.setFieldValue(`policyMembers[${index}].${field}`, value)
  }

  const handleZipCodeLookup = () => {
    if ((formik.values?.zipCode?.length ?? 0) < 3) return
    getMarketByZip(formik.values.zipCode ?? '')
  }

  const getMarketByZip = useCallback((zipCode: string) => {
    gqlGetMarket({
      variables: {zipCode},
    })
  }, [gqlGetMarket])

  useEffect(() => {
    if (!dataZipCode?.zipcodeByZip) return

    const stateId = dataZipCode?.zipcodeByZip?.stateId ?? ''
    const stateName = dataZipCode?.zipcodeByZip?.stateName ?? ''
    const defaultCountyFips = dataZipCode?.zipcodeByZip?.countyFipsAll?.split('|')[0] || ''

    handleChange('stateEU.code', stateId)
    handleChange('stateEU.name', stateName)
    handleChange('countyFips', defaultCountyFips)
  }, [dataZipCode, handleChange])

  useEffect(() => {
    if (!isMedicarePolicyFlow) return

    const allTypes =
      allPolicyTypeCategories?.allCategoryPolicy?.edges?.flatMap(({node}) =>
        node.policyTypeSet?.edges?.map(({node: typeNode}) => typeNode) || []
      ) || []

    if (allTypes.length === 0) return

    const medicareType = allTypes.find((typeNode) =>
      (typeNode.typePolicy || '').toLowerCase().includes('medicare')
    )

    if (medicareType?.id) {
      const typeId = String(parseId(medicareType.id))
      setMedicareTypeId(typeId)
      handleChange('typePolicy.id', typeId)
      setLockPolicyType(true)
    } else if (!warnedMissingMedicareTypeRef.current) {
      warnedMissingMedicareTypeRef.current = true
      toast.warning('No Medicare policy type found. Please configure one in Policy Types.')
    }
  }, [allPolicyTypeCategories, handleChange, isMedicarePolicyFlow])

  useEffect(() => {
    if (!isMedicarePolicyFlow || isAgent) return

    const sources = dataLeadSource?.allLeadSources?.edges?.map(({node}) => node) || []
    if (sources.length === 0) return

    const medicareSource = sources.find((source) =>
      (source.name || '').toLowerCase().includes('medicare')
    )

    if (medicareSource?.id) {
      const sourceId = String(parseId(medicareSource.id))
      setMedicareSourceId(sourceId)
      handleChange('leadSource.id', sourceId)
      setLockLeadSource(true)
    } else if (!warnedMissingMedicareSourceRef.current) {
      warnedMissingMedicareSourceRef.current = true
    }
  }, [dataLeadSource, handleChange, isMedicarePolicyFlow, isAgent])

  // ACA type auto-selection when coming from Quick Quote flow
  useEffect(() => {
    if (!isAcaFlow) return

    const allTypes =
      allPolicyTypeCategories?.allCategoryPolicy?.edges?.flatMap(({node}) =>
        node.policyTypeSet?.edges?.map(({node: typeNode}) => typeNode) || []
      ) || []

    if (allTypes.length === 0) return

    const acaType = allTypes.find((typeNode) =>
      (typeNode.typePolicy || '').toUpperCase().includes('ACA')
    )

    if (acaType?.id) {
      handleChange('typePolicy.id', String(parseId(acaType.id)))
      setLockPolicyType(true)
    } else if (!warnedMissingAcaTypeRef.current) {
      warnedMissingAcaTypeRef.current = true
      toast.warning('No ACA policy type found. Please configure one in Policy Types.')
    }
  }, [allPolicyTypeCategories, handleChange, isAcaFlow])

  // Carrier lookup from plan issuer name
  useEffect(() => {
    if (!planSelectPrev?.issuer?.name) return
    gqlGetOrCreateOperator({variables: {name: planSelectPrev.issuer.name}})
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [planSelectPrev?.issuer?.name])

  // Set carrier.id when operator is resolved — match relay ID from carriers list
  useEffect(() => {
    if (!dataCarrierOp?.getOrCreateInsuranceOperatorByName?.success) return
    const opId = dataCarrierOp.getOrCreateInsuranceOperatorByName.insuranceOperatorId
    if (!opId || !dataCarriersList?.allInsuranceOperatorsList) return

    const opIdStr = String(opId)
    const matched = dataCarriersList.allInsuranceOperatorsList.find(
      (c) =>
        String(c.id) === opIdStr ||
        String(parseId(c.id)) === String(parseId(opIdStr))
    )

    if (matched?.id) handleChange('carrier.id', matched.id)
  }, [dataCarrierOp, dataCarriersList, handleChange])

  // Zip lookup from Quick Quote zip code
  useEffect(() => {
    if (!quickQuoteData?.zipCode) return
    getMarketByZip(quickQuoteData.zipCode)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [quickQuoteData?.zipCode])

  // Warn when age is given but DOB is missing
  useEffect(() => {
    if (!quickQuoteData) return
    if (!quickQuoteData.personOne.dob && quickQuoteData.personOne.age) {
      toast.warning(
        `Holder age is ${quickQuoteData.personOne.age} years. Please enter the exact date of birth to continue.`
      )
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const [zipInput, setZipInput] = useState(formik.values.zipCode || '')

  useEffect(() => {
    // ⏳ si el usuario deja de escribir 500ms, dispara la búsqueda
    const handler = setTimeout(() => {
      if (zipInput && zipInput.length >= 3) {
        getMarketByZip(zipInput)
      }
    }, 500)

    return () => {
      clearTimeout(handler) // limpia el timeout si sigue escribiendo
    }
  }, [getMarketByZip, zipInput])

  return (
    <Modal
      className='modal-add-policy'
      backdrop='static'
      keyboard={false}
      show={isOpen}
      onHide={onClose}
      size='xl'
    >
      <Modal.Header closeButton>
        <Modal.Title>
          {isQuote && isAcaFlow
            ? 'Create a new ACA quote'
            : isQuote
            ? 'Create a new quote'
            : isMedicarePolicyFlow
            ? 'Create a new Medicare policy'
            : 'Create a new policy'}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Row>
          <Col
            xl={3}
            lg={4}
            className='d-none d-md-none d-lg-block'
            style={{
              borderRight: '1px solid #eeeef4',
            }}
          >
            <div>
              {filteredTabs.map((tb) => (
                <div
                  key={tb.tabName}
                  className='d-flex align-items-center gap-2 p-5 rounded'
                  style={{
                    backgroundColor: tb.tabName === tabForm ? '#e7e7ff' : undefined,
                    position: 'relative',
                    maxWidth: '330px',
                  }}
                  role='button'
                  onClick={() => {
                    if (loadingCreate || loadingCreateQuote) return
                    setTabForm(tb.tabName)
                  }}
                >
                  {tb.tabName === tabForm && (
                    <div
                      style={{
                        left: '100%',
                        top: '50%',
                        transform: 'translateY(-50%)',
                        content: ' ',
                        height: 0,
                        width: 0,
                        border: 'solid transparent',
                        position: 'absolute',
                        borderLeftColor: '#e7e7ff',
                        borderWidth: '1rem',
                      }}
                    />
                  )}
                  <div>
                    <i className={`${tb.icon} fs-1`} style={{color: 'inherit'}} />
                  </div>
                  <div>
                    <h6 style={{fontSize: '11px'}} className='m-0'>
                      {tb.name}
                    </h6>
                    <p style={{fontSize: '10px'}} className='m-0'>
                      {tb.description}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </Col>
          <Col lg={8} xl={9}>
            {formik.values.policyName &&
              formik.values.policyName !== '' &&
              formik.values.policyName.length > 0 && (
                <div>
                  <Form.Group className='policy-name'>
                    <div>
                      <Form.Label>Policy Name</Form.Label>
                    </div>
                    <div className='w-50'>
                      <Form.Control
                        onChange={(e) => handleChange('policyName', e.target.value)}
                        value={formik.values.policyName}
                        readOnly
                      />
                    </div>
                  </Form.Group>
                </div>
              )}
            <div className='policy-form'>
              {tabForm === 'policy-holder' && (
                <PolicyHolderTabModal
                  onPrevStep={() => {}}
                  onNextStep={handleNextTab}
                  handleChange={(field, value) => handleChange(`holder.${field}`, value)}
                  handleBlur={(field) => handleBlur(`holder.${field}`)}
                  values={formik.values.holder}
                  errors={formik.errors.holder ?? {}}
                  touched={formik.touched.holder ?? {}}
                  policyValues={{
                    ownsCar: formik.values.ownsCar,
                    ownsHome: formik.values.ownsHome,
                  }}
                  policyErrors={formik.errors}
                  policyTouched={formik.touched}
                  onPolicyChange={(field, value) => handleChange(field, value)}
                  onPolicyBlur={(field) => handleBlur(field)}
                  submitCount={submitAttemptCount}
                  showSearchContact={!(infoEditContact && infoEditContact.id)}
                />
              )}
              {tabForm === 'policy-info' && (
                <></>
                // <QuoteInfoTab
                //   onNext={() => setTabForm('address-info')}
                //   onPrev={() => setTabForm('policy-info')}
                //   handleChange={handleChange}
                //   handleBlur={handleBlur}
                //   values={formik.values}
                //   policiesType={allPoliciesType}
                // />
              )}
              {tabForm === 'address-info' && (
                <AddressInfoTab
                  handleZipCodeLookup={handleZipCodeLookup}
                  onPrev={handlePrevTab}
                  onNext={handleNextTab}
                  handleChange={(field, value) => {
                    handleChange(field, value)
                    if (field === 'zipCode') {
                      setZipInput(value) // 👈 actualiza zipInput en tiempo real
                    }
                  }}
                  loadingZipCode={loadingZipCode}
                  dataZipCode={dataZipCode}
                  handleBlur={handleBlur}
                  values={formik.values}
                  errors={formik.errors}
                  touched={formik.touched}
                />
              )}
              {tabForm === 'household-info' && (
                <HouseholdInfoTab
                  onPrev={handlePrevTab}
                  onNext={handleNextTab}
                  handleChange={handleChange}
                  handleBlur={handleBlur}
                  values={formik.values}
                  errors={formik.errors}
                  touched={formik.touched}
                />
              )}
              {tabForm === 'family-members' && (
                <FamilyMembersTabModal
                  onPrev={handlePrevTab}
                  onNext={handleNextTab}
                  members={formik.values.policyMembers}
                  onChange={handleMemberChange}
                  onAdd={addPolicyMember}
                  onRemove={removePolicyMember}
                />
              )}
              {tabForm === 'basic-policy-info' && (
                <BasicPolicyInfoTab
                  onSubmit={handleSubmit}
                  onPrev={handlePrevTab}
                  handleChange={handleChange}
                  handleBlur={handleBlur}
                  values={formik.values}
                  errors={formik.errors}
                  touched={formik.touched}
                  policiesType={allPolicyTypeCategories}
                  leadSources={dataLeadSource}
                  loading={loadingCreate ? loadingCreateQuote : false}
                  dataUsers={dataUsers}
                  loadingUsers={loadingUsers}
                  gqlGetMembers={gqlGetMembers}
                  lockPolicyType={lockPolicyType}
                  lockLeadSource={lockLeadSource}
                />
              )}
            </div>
          </Col>
        </Row>
      </Modal.Body>
      {/* <Modal.Footer>
        <Button variant='secondary' onClick={onClose}>
          Close
        </Button>
        <Button variant='primary' onClick={onClose}>
          Save Changes
        </Button>
      </Modal.Footer> */}
    </Modal>
  )
}
